import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/billingPortal/actions/config';
import { func_serviceHandling, func_validation, getTotalCountFromHeader, isArrayNotEmpty, isStringEqual_caseInsensitive } from 'functions';
import { useState } from 'react';

export function useTableData(props) {
    const [data, setData] = useState();
	const [isDataLoading, setIsDataLoading] = useState();
	const [totalRecords, setTotalRecords] = useState();
    const request = usePromiseInstance_authorization();


    function getData(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetRequest', paramObj)

		setIsDataLoading(true);

        request(null, (axios) => {
			axios.get(url)
				.then(function (response) {
					// handle success
					setTotalRecords(getTotalCountFromHeader(response?.headers))
					let data = response?.data;
					if (isArrayNotEmpty(data)) {
						data = data.map((obj) => {
							let status = obj?.RequestStatus;

							return {
								...obj,
								isCheckboxDisabled: isStringEqual_caseInsensitive(status, "Done") || 
									isStringEqual_caseInsensitive(status, "Rejected")
							}
						})
						setData(data);
					}
					else setData([]);
				})
				.catch(function (response) {
					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
					setIsDataLoading(false);
				});
		})
    }

    return {
        getData,
        data, totalRecords,
		isDataLoading
    }
}